/*
 * $Id:: AuthContainer.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    pageCanvas: {
        height: '100%',
        padding: '2rem 4rem 0',
        '@media (max-width:600px)': {
            padding: '2rem 1rem 0',
        },
    },
    title: {
        color: theme.palette.text.blueGray,
        '& h5': {
            fontWeight: '600',
            letterSpacing: '0.05rem',
        },
        marginBottom: '2.75rem',
        '@media (max-width:960px)': {
            alignItems: 'unset',
        },
    },
    preTitle: {
        backgroundColor: theme.palette.text.primary,
        borderRadius: '16px',
        width: '2.75rem',
        minWidth: '2.75rem',
        height: '2.75rem',
        minHeight: '2.75rem',
        textAlign: 'center',
        '& h5': {
            lineHeight: '29px',
            '& path': {
                fill: theme.palette.text.blueGray,
            },
            '@media (max-width:600px)': {
                fontSize: '125%',
            },
        },
    },
    mainTitle: {
        '@media (max-width:600px)': {
            fontSize: '125%',
        },
    },
    AuthContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        'flex-wrap': 'wrap',
        paddingLeft: '2.75rem',
        '@media (max-width:600px)': {
            paddingLeft: '0',
        },
    },
}));

const AuthContainer = ({ preTitle, title, children }) => {
    const classes = useStyles();
    return (
        <div className={classes.pageCanvas}>
            <Grid container spacing={2} alignItems="center" className={classes.title} wrap="nowrap">
                <Grid item className={classes.preTitle}>
                    <Typography variant="h5">{preTitle}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="h5" className={classes.mainTitle}>
                        {title}
                    </Typography>
                </Grid>
            </Grid>
            <Container className={classes.AuthContainer} disableGutters>
                {children}
            </Container>
        </div>
    );
};

export default AuthContainer;
